import { TabSelect, Divider } from 'mondrian-react';
import styles from './styles.module.css';

function Tabelas({ result }) {
  return (
    <TabSelect
      data={[
        {
          title: 'Descrição',
          content: (
            <>
              <Divider className={styles.Divider} />
              <div
                className={`mdn-ProductDetailsHorizontal ${styles.ContainerTable}`}
              >
                <table>
                  <tbody>
                    <tr>
                      <td>Nome da tabela</td>
                      <td>{result._source.tabela}</td>
                    </tr>
                    <tr>
                      <td>Descrição da Tabela</td>
                      <td>{result._source.descr}</td>
                    </tr>
                    <tr>
                      <td>Domínio do Negócio</td>
                      <td>{result._source.dominioNegocio}</td>
                    </tr>
                    <tr>
                      <td>Domínio do Dado</td>
                      <td>{result._source.dominioDado}</td>
                    </tr>
                    <tr>
                      <td>Subdomínio do Dado</td>
                      <td>{result._source.subdominioDado}</td>
                    </tr>
                    <tr>
                      <td>Database</td>
                      <td>{result._source.database}</td>
                    </tr>
                    <tr>
                      <td>Origem</td>
                      <td>{result._source.origem}</td>
                    </tr>
                    <tr>
                      <td>Data Owner</td>
                      <td>{result._source.dataOwner}</td>
                    </tr>
                    <tr>
                      <td>Data Steward</td>
                      <td>{result._source.dataSteward}</td>
                    </tr>
                    <tr>
                      <td>Confidencialidade</td>
                      <td>{result._source.confidencialidade}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </>
          ),
        },
        {
          title: 'Colunas',
          content: (
            <>
              <Divider className={styles.Divider} />
              <div
                className={`mdn-ProductDetailsHorizontal ${styles.ContainerTableColunas}`}
              >
                <table>
                  <tbody>
                    <tr>
                      <th>Coluna</th>
                      <th>Descrição</th>
                      <th>Tipo</th>
                    </tr>
                    {result._source.colunas?.map((item, i) => {
                      return [
                        <tr key={i}>
                          <td>{item.coluna}</td>
                          <td>{item.descr}</td>
                          <td>{item.tipo}</td>
                        </tr>,
                      ];
                    })}
                  </tbody>
                </table>
              </div>
            </>
          ),
        },
      ]}
    />
  );
}

export default Tabelas;
